/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesMembersEditRights = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesMembersEditRights = typeof WebApiModelsEnumerationTypesMembersEditRights[keyof typeof WebApiModelsEnumerationTypesMembersEditRights];


export function WebApiModelsEnumerationTypesMembersEditRightsFromJSON(json: any): WebApiModelsEnumerationTypesMembersEditRights {
    return WebApiModelsEnumerationTypesMembersEditRightsFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesMembersEditRightsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesMembersEditRights {
    return json as WebApiModelsEnumerationTypesMembersEditRights;
}

export function WebApiModelsEnumerationTypesMembersEditRightsToJSON(value?: WebApiModelsEnumerationTypesMembersEditRights | null): any {
    return value as any;
}

